import { useEffect } from "react";

const upsert = (selector, attrs) => {
  let el = document.head.querySelector(selector);
  if (!el) {
    el = document.createElement(attrs.tag || "meta");
    document.head.appendChild(el);
  }
  Object.entries(attrs).forEach(([k, v]) => k !== "tag" && el.setAttribute(k, v));
  return el;
};

export const Seo = ({ title, description, path = "/", type = "website", image, jsonLd }) => {
  useEffect(() => {
    document.title = title;
    upsert('meta[name="description"]', { name: "description", content: description });
    upsert('meta[property="og:title"]', { property: "og:title", content: title });
    upsert('meta[property="og:description"]', { property: "og:description", content: description });
    upsert('meta[property="og:type"]', { property: "og:type", content: type });
    upsert('meta[name="twitter:title"]', { name: "twitter:title", content: title });
    upsert('meta[name="twitter:description"]', { name: "twitter:description", content: description });
    if (image) {
      const abs = `${window.location.origin}${image}`;
      upsert('meta[property="og:image"]', { property: "og:image", content: abs });
      upsert('meta[name="twitter:image"]', { name: "twitter:image", content: abs });
    }
    let script;
    if (jsonLd) {
      script = document.createElement("script");
      script.type = "application/ld+json";
      script.setAttribute("data-seo", "route");
      script.text = JSON.stringify(jsonLd);
      document.head.appendChild(script);
    }
    return () => { script?.remove(); };
  }, [title, description, path, type, image, jsonLd]);
  return null;
};
